/**
 * Hearing Test
 * @class HearingTest
 */
import {htSignUpHandler} from "../handlers/formHandlers";

export default class HearingTest {

  constructor(context) {
    this.context = context;
    this.selectors = {
      playButton: '.play-button',
      audioFiles: '[data-audio-files]',
      imageFiles: '[data-image-files]',
      page: '.hearing-test--page',
      pageTop: 'pageTop',
      stepLabel: '.hearing-test--step--label',
      paginationBtn: '.pagination--button',
      paginationControl: '.pagination--controls--button',
      paginationPrev: '.pagination--controls--prev',
      paginationNext: '.pagination--controls--next',
      tabButton: '.tab--item--button',
      resultsSelector: '.results-grid--results',
      resultsContainer: '.hearing-test--results-grid--container',
      resultsGrid: 'resultsGrid',
      resultsEmailBtn: '.results-grid--email-btn',
      resultsEmailDeets: '.results-grid--email-details',
      hsResultsContainer: '.hs_hearing_test_results___online',
      hsCategoryContainer: '.hs_hearing_test_results_category',
      htSignUpId: 'ht-sign_up',
    };
    this.mode = "B"; // (B)oth (L)eft or (R)ight
    this.allHearingBands = [250,375,500,750,1000,1500,2000,3000,4000,6000,8000];
    this.allHearingDBHL = [-5,0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80];
    this.tetraHearingBands = [500,1000,2000,3000];
    this.tetraHearingDBHL = [-5,0,5,10,15,20,30,40,50,60,70,80];
    this.printURL = null;
    this.backURL = null;
    this.overlay = 0;
    this.fileExt = ".mp3";
    this.fileSuffixForLRMode = "";
    this.fileNameArray = [];
    this.filesJSON = JSON.parse(document.querySelectorAll(this.selectors.audioFiles).item(0).innerHTML);
    this.imageJSON = JSON.parse(document.querySelectorAll(this.selectors.imageFiles).item(0).innerHTML);
    this.audioArray = [];
    this.allAudioButtons = [];
    this.resultMatrix = [];
    this.page = "1";
    this.pageId = {
      1: 'pageOne',
      2: 'pageTwo',
      3: 'pageThree',
      4: 'pageFour'
    };
    this.dBMarkers = {
      1: 'dB',
      4: '0',
      9: '10',
      14: '20',
      19: '30',
      24: '40',
      29: '50',
      34: '60',
      39: '70',
      44: '80'
    };

    this.HzMarkers = {
      2: 'Hz',
      5: '500',
      10: '1000',
      15: '2000',
      19: '3000'
    };
    this.tabs = null;
    this.addresses = 'william@tetrahearing.com,info@tetrahearing.com';
    this.orderId = this._getOrderIdParam();
    this.validation = {'L': false, 'R': false};
    this.htSignUpForm = document.getElementById(this.selectors.htSignUpId);
    this._init();
  }


  /**
   * Gets the order id param.
   * @return {*}
   * @private
   */
  _getOrderIdParam () {
    const url = window.location.href;
    const regex = new RegExp('[?&]orderId(=([^&#]*)|&|#|$)');
    const orderId = regex.exec(url);
    if (!orderId) return null;
    if (!orderId[2]) return '';
    return decodeURIComponent(orderId[2].replace(/\+/g, ' '));
  }

  /**
   * Generates Hearing Test Table
   * @param opts
   */
  tableGen(opts) {

    const freqs = opts.freqs;
    const dBHLs = opts.dBHLs;
    const mode = opts.mode;
    const tableId = opts.tableId;

    let content = "<table class='hearing-test'>";
    content += "<tr>";
    content += "<td>&nbsp;</td>";
    content += "<td><div class='hearing-test--col-header'>1</div></td>";
    content += "<td><div class='hearing-test--col-header'>2</div></td>";
    content += "<td><div class='hearing-test--col-header'>3</div></td>";
    content += "<td><div class='hearing-test--col-header'>4</div></td>";
    content += "</tr>";

    for (let i=0; i < dBHLs.length; i++) {
      content += "<tr>";
      if (dBHLs[i] === -5) content += "<td class='hearing-test--row-header' rowspan='2'><div><div class='hearing-test--sound-descr'>Almost Silent</div></div></td>";
      if (dBHLs[i] === 5) content += "<td class='hearing-test--row-header' rowspan='4'><div><div class='hearing-test--sound-descr'>Quiet</div></div></td>";
      if (dBHLs[i] === 30) content += "<td class='hearing-test--row-header' rowspan='4'><div><div class='hearing-test--sound-descr'>Louder</div></div></td>";
      if (dBHLs[i] === 70) content += "<td class='hearing-test--row-header' rowspan='2'><div><div class='hearing-test--sound-descr'>VERY LOUD</div></div></td>";
      for (let j=0; j < freqs.length; j++) {
        let classes = null;
        if ([0, 20, 60, 80].includes(dBHLs[i])) {
          classes = 'bottom-spacer';
        }

        if ([-5, 5, 30, 70].includes(dBHLs[i])) {
          classes = 'top-spacer';
        }
        content += "<td>";
        content += `<div class='audio-button--container ${classes}'>`;
        content += `<svg class='t-icon t-icon-white' data-targetid='hearingTest.online.warble_${freqs[j]}_${dBHLs[i]}_${mode}'>`;
        content +=  `<g><path d="M10.596,2.97v13.907c0,0.6-0.492,0.991-1,0.991c-0.243,0-0.492-0.089-0.694-0.289l-3.684-3.685H0.993C0.444,13.896,0,13.451,0,12.902V6.943C0,6.394,0.444,5.95,0.993,5.95h4.224L8.9,2.268c0.201-0.201,0.451-0.291,0.694-0.291 C10.104,1.976,10.596,2.37,10.596,2.97z M15.895,9.923c0,1.32-0.726,2.539-1.894,3.183c-0.481,0.264-1.085,0.094-1.353-0.391 c-0.263-0.48-0.09-1.084,0.393-1.351c0.535-0.294,0.866-0.847,0.866-1.441c0-0.594-0.331-1.146-0.866-1.44 c-0.482-0.266-0.655-0.87-0.393-1.349c0.265-0.48,0.871-0.654,1.353-0.392C15.169,7.384,15.895,8.604,15.895,9.923z M19.868,9.923 c0,2.612-1.325,5.013-3.548,6.425c-0.496,0.312-1.104,0.118-1.372-0.309c-0.296-0.463-0.157-1.077,0.306-1.369 c1.645-1.045,2.627-2.816,2.627-4.747c0-1.927-0.982-3.7-2.627-4.744c-0.463-0.293-0.602-0.906-0.306-1.372 c0.292-0.463,0.905-0.601,1.372-0.306C18.543,4.911,19.868,7.312,19.868,9.923z" /> </g>`;
        content += "</svg>";
        content += `<div class='play-button audio-button' id='hearingTest.online.warble_${freqs[j]}_${dBHLs[i]}_${mode}' data-mode='${mode}' data-file-name='hearingTest.online.warble_${freqs[j]}_${dBHLs[i]}_${mode}' title='Click to Play ${freqs[j]}Hz@${dBHLs[i]}' data-gtm-event="hearing-test-interaction">`;
        content += '</div>';
        content += '</div>';
        content += "</td>";
      }
      content += "</tr>";
    }

    content += "</table>";

    document.getElementById(tableId).innerHTML = content;

    this._playButtonFactory();

  }

  genResultsGrid() {
    let content = "<table class='hearing-test--results-grid'>";

    // Rows
    for (let i=0; i < 50; i++) {
      let rowClasses = '';

      // Adds strong border to bottom of row.
      if ([4,9,14,19,24,29,34,39,44].includes(i)) {
        rowClasses += 'border-bottom';
      }

      // Shades rows
      if (i >= 20) {
        rowClasses += ' field-shaded';
      }

      if (i >= 36) {
        rowClasses += ' clinical-shaded';
      }

      content += `<tr>`;

      // Columns
      for (let j=0; j < 20; j++) {
        let colClasses = null;
        let containerId = null;
        let labelDiv = null;
        let sectionLabel = null;
        let areaDescript = null;
        let animalIcon = null;
        let adjustClass = '';
        let bracket = '';

        // Identifies containers that contain results.
        switch (j) {
          case 4:
            containerId = 'Hz500';
            break;
          case 9:
            containerId = 'Hz1000';
            break;
          case 14:
            containerId = 'Hz2000';
            break;
          case 19:
            containerId = 'Hz3000';
        }

        if (containerId) {
          let dB = '';
          // @todo: use maths
          switch (i) {
            case 3:
              dB = '-5';
              adjustClass = 'half-value';
              break;
            case 5:
              dB = '0';
              break;
            case 8:
              dB = '5';
              adjustClass = 'half-value';
              break;
            case 10:
              dB = '10';
              break;
            case 13:
              dB = '15';
              break;
            case 15:
              dB = '20';
              break;
            case 20:
              dB = '30';
              break;
            case 25:
              dB = '40';
              break;
            case 30:
              dB = '50';
              break;
            case 35:
              dB = '60';
              break;
              break;
            case 40:
              dB = '70';
              break;
            case 45:
              dB = '80';
              break;
          }
          containerId += `dB${dB}`;
        }

        // Creates strong vertical border.
        if ([4,9,14].includes(j)) {
          colClasses = 'border-right';
        }

        // Adds vertical table labels
        if (j === 0 && this.dBMarkers[i] !== undefined) {
          labelDiv = `<div class="results-grid--label left"><span>${this.dBMarkers[i]}</span></div>`;
        }

        // Adds horizontal table labels
        if (i === 0 && this.HzMarkers[j] !== undefined) {
          if (j === 19) {
            labelDiv = `<div class="results-grid--label top last"><span>${this.HzMarkers[j]}</span></div>`;
          } else {
            labelDiv = `<div class="results-grid--label top"><span>${this.HzMarkers[j]}</span></div>`;
          }
        }

        // Adds section labels
        if (i === 9 && j === 0) {
          sectionLabel = `<div class="results-grid--label--section">Normal Hearing</div>`;
        }

        if (i === 34 && j === 0) {
          sectionLabel = `<div class="results-grid--label--section">Severe Hearing Loss</div>`;
        }

        // Add area descriptions
        if (i === 21 && j === 19) {
          areaDescript = `<div class="results-grid--area-descript clinical">No, everyone is NOT mumbling... its your ears!</div>`;
          areaDescript += `<div class="results-grid--area-descript field"><strong>If your hearing levels are here:</strong><br />You can't hear or locate that gobble <br />Deer are sneaking up on you before you hear them</div>`;
        }

        if (i === 32 && j === 19) {
          areaDescript = `<div class="results-grid--area-descript field"><strong>If your hearing levels are here:</strong><br />You are the last gun shooting, since you didn’t hear “Take ‘em”<br />And you spook everything in the woods, since you cant hear how much noise you make walking</div>`;
        }

        if (i === 31 && j === 19) {
          areaDescript = `<div class="results-grid--area-descript clinical">Everyone who knows you, knows you struggle to hear.</div>`;
        }

        if (i === 42 && j === 19) {
          areaDescript = `<div class="results-grid--area-descript clinical">You will be surprised how much better life will be with TETRA.</div>`;
        }

        // Add description brackets
        if (i === 19 && j === 19) {
          bracket = '<div class="results-grid--bracket field top"></div>';
          bracket += '<div class="results-grid--bracket clinical top"></div>';
        }

        if (i === 25 && j === 19) {
          bracket = '<div class="results-grid--bracket clinical bottom"></div>';
        }

        if (i === 29 && j === 19) {
          bracket = '<div class="results-grid--bracket clinical top"></div>';
          bracket += '<div class="results-grid--bracket field bottom"></div>';
        }

        if (i === 31 && j === 19) {
          bracket = '<div class="results-grid--bracket field top"></div>';
        }

        if (i === 35 && j === 19) {
          bracket = '<div class="results-grid--bracket clinical bottom"></div>';
        }

        if (i === 37 && j === 19) {
          bracket = '<div class="results-grid--bracket clinical top"></div>';
        }

        if (i === 42 && j === 19) {
          bracket = '<div class="results-grid--bracket field bottom"></div>';
        }

        if (i === 49 && j === 19) {
          bracket = '<div class="results-grid--bracket clinical bottom"></div>';
        }

        // Adds animal sound icons
        if (i === 22 && j === 14) {
          animalIcon = `<div class="results-grid--animal-icon" style="top: -24px;"><img src="${this.imageJSON['icon-turkey-solid']}"/></div>`;
        }

        if (i === 26 && j === 14) {
          animalIcon = `<div class="results-grid--animal-icon" style="top: -34px;"><img src="${this.imageJSON['icon-deer-solid']}"/></div>`;
        }

        if (i === 29 && j === 14) {
          animalIcon = `<div class="results-grid--animal-icon" style="top: -32px;"><img src="${this.imageJSON['icon-duck-solid']}"/></div>`;
        }

        if (i === 32 && j === 14) {
          animalIcon = `<div class="results-grid--animal-icon" style="top: -32px;"><img src="${this.imageJSON['icon-elk-solid']}"/></div>`;
        }

        content += `<td class='results-grid--unit ${colClasses} ${rowClasses}'>`;
        content += containerId ? `<div id='${containerId}' class='results-grid--unit--container ${adjustClass}'>` : "<div class='results-grid--unit--container'>";

        if (labelDiv) {
          content += labelDiv;
        }

        if (sectionLabel) {
          content += sectionLabel;
        }

        if (areaDescript) {
          content += areaDescript;
        }

        if (animalIcon) {
          content += animalIcon;
        }

        if (bracket) {
          content += bracket;
        }

        content += "</div>";
        content += "</td>";
      }
      content += "</tr>";
    }

    content += "</table>";

    content += '<p style="margin: 0 auto; width: 300px">';
    content += '<small>*GOBBLE, SNORT, HAIL, BUGLE AT 100 YARDS</small><br />';
    content += '<svg class="t-icon t-icon-sm t-icon-blue"><use xlink:href="#icon-close"></use></svg> <small>LEFT</small>    ';
    content += '&nbsp;&nbsp;<svg class="t-icon t-icon-sm t-icon-red"><use xlink:href="#icon-donut"></use></svg> <small>RIGHT</small>';
    content += '</p>';


    document.getElementById(this.selectors.resultsGrid).insertAdjacentHTML('afterbegin', content);
  }

  /**
   *
   */
  initResultMatrix() {
    for (let i = 0; i < this.tetraHearingBands.length; i++) {
      for (let j = 0; j < this.tetraHearingDBHL.length; j++) {
        this.resultMatrix["L"][this.tetraHearingBands[i]][this.tetraHearingDBHL[j]] = 0;
        this.resultMatrix["R"][this.tetraHearingBands[i]][this.tetraHearingDBHL[j]] = 0;
      }
    }
  }

  /**
   * Updates Result Matrix with selected values.
   * @param soundFile
   * @param mode
   */
  updateResultMatrix(soundFile, mode) {
    const tmp = soundFile.split("_");

    const x = tmp[1];
    const y = tmp[2];
    const z = tmp[3];

    document.getElementById(`${tmp[0]}_${tmp[1]}_${tmp[2]}_${tmp[3]}`).parentNode.classList.add('selected');

    for (let j=0; j < this.tetraHearingDBHL.length; j++) {
      this.resultMatrix[mode][x][this.tetraHearingDBHL[j]] = 0;
    }

    this.resultMatrix[mode][x][y]=1;
  }

  /**
   * Clears Tables
   * @todo: link to associated button.
   */
  clearTable() {
    for (let i=0; i < this.allHearingBands.length; i++) {
      document.getElementById('overB' + this.allHearingBands[i]).innerHTML = "";
      document.getElementById('overL' + this.allHearingBands[i]).innerHTML = "";
      document.getElementById('overR' + this.allHearingBands[i]).innerHTML = "";
    }
    this.initResultMatrix();
  }

  /**
   * Gets url params.
   */
  getUrlVars() {
    const vars = {};

    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {
      vars[key] = value;
    });

    return vars;
  }

  /**
   * Clears existing results.
   * @private
   */
  _clearResultMatrix() {
    const results = Array.from(document.querySelectorAll(this.selectors.resultsSelector));

    results.forEach(el => {
      el.parentNode.removeChild(el);
    });
  }

  /**
   * Plots results and add results to email button data attribute.
   */
  _plotResultMatrix() {

    const modes = ['L', 'R'];
    //const emailBtn = document.querySelectorAll(this.selectors.resultsEmailBtn).item(0);
    //const emailContainer = document.querySelectorAll(this.selectors.resultsEmailDeets).item(0);
    //let emailData = "";
    //let emailMarkup = "<p>Didn't work?</p>" +
    //  "<p><small>Email to:</small> <br />" +
    //  this.addresses +
    //  "</p>";
    //  if (this.orderId) {
    //    emailMarkup += `<p><small>Subject:</small><br /> Order Results: ${this.orderId} </p>`;
    //  } else {
    //    emailMarkup += "<p><small>Subject:</small><br /> TETRA Hearing Results</p>";
    //  }
    //  emailMarkup += "<p><small>Include:</small></p>";
    const hsDataInputField = document.querySelectorAll(this.selectors.hsResultsContainer).item(0).querySelectorAll('[name="hearing_test_results___online"]').item(0);
    const hsCategoryInputField = document.querySelectorAll(this.selectors.hsCategoryContainer).item(0).querySelectorAll('[name="hearing_test_results_category"]').item(0);

    modes.forEach((mode) => {
      // Set Hubspot hearing category to default
      let hsHearingCategory = "standard";

      for (let i = 0; i < this.tetraHearingBands.length; i++) {

        for (let j = 0; j < this.tetraHearingDBHL.length; j++) {
          if (this.resultMatrix[mode][this.tetraHearingBands[i]][this.tetraHearingDBHL[j]] !== 0) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
            const use = document.createElementNS('http://www.w3.org/2000/svg','use');
            switch (mode) {
              case "L":
                svg.setAttribute('class', 't-icon t-icon-blue');
                use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', "#icon-close");
                break;
              case "R":
                svg.setAttribute('class', 't-icon t-icon-red');
                use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', "#icon-donut");
                break;
            }

            //emailData += `${mode}: ${this.tetraHearingBands[i]}Hz ${this.tetraHearingDBHL[j]}dB %0A`;
            //emailMarkup += `${mode}: ${this.tetraHearingBands[i]}Hz ${this.tetraHearingDBHL[j]}dB <br />`;
            hsDataInputField.value += `${mode}: ${this.tetraHearingBands[i]}Hz ${this.tetraHearingDBHL[j]}dB \n`;

            if (this.tetraHearingDBHL[j] >= 30) {
              hsHearingCategory = 'loss';
            }

            svg.appendChild(use);
            const resultsContainer =  document.getElementById(`Hz${this.tetraHearingBands[i]}dB${this.tetraHearingDBHL[j]}`);
            if (!resultsContainer) {
              continue;
            }
            const div = document.createElement('div');
            div.classList.add('results-grid--results');
            div.appendChild(svg);
            resultsContainer.appendChild(div);
          }
        }
      }

      // Set Hubspot category field.
      hsCategoryInputField.value = hsHearingCategory;


      //if (emailData) {
      //  emailData += '%0A';
      //  emailMarkup += '<br />';
      //}
    });

    //if (emailData) {
    //  const body = emailData;//write the message text between the speech marks or put a variable in the place of the speech marks
    //  const subject = this.orderId ? `Order Results: ${this.orderId}` : "Tetra Hearing Results";//between the speech marks goes the subject of the message
    //  const href = "mailto:" + this.addresses + "?"
    //    + "subject=" + subject + "&"
    //    + "body=" + body;
//
    //  emailBtn.setAttribute('href', href);
    //  emailContainer.innerHTML = emailMarkup;
    //} else {
    //  emailContainer.innerHTML = 'No data entered. Please start at step one.';
    //}
  }

  /**
   *
   */
  _checkCompleted(mode){
    let tot = 0;

    for (let i=0; i < this.tetraHearingBands.length; i++) {
      for (let j=0; j < this.tetraHearingDBHL.length; j++) {

        tot += this.resultMatrix[mode][this.tetraHearingBands[i]][this.tetraHearingDBHL[j]];
      }
    }

    if (tot === 4){
      this.validation[mode] = true;
      this._setNextControlState();
      this._setPaginationState();
    }
  }

  /**
   *
   */
  checkAudioFileCompatibility(){
    const a = document.createElement('audio');
    if (!!(a.canPlayType && a.canPlayType('audio/ogg; codecs="vorbis"').replace(/no/, ''))) this.fileExt=".ogg";
  }

  /**
   * Manages playing sound file.
   *
   * @param el
   */
  play(el){
    const mode = el.getAttribute('data-mode');
    const soundFile = el.getAttribute('data-file-name');
    const fileIndex = soundFile.replace('hearingTest.online.', '') + this.fileExt;

    const soundFileUrl = this.filesJSON[fileIndex];

    let i = this.fileNameArray.indexOf(soundFile);

    if (mode) {
      this.clearLast(soundFile);
    }

    for (let k = 0; k < this.audioArray.length; k++) {
      if (k !== i && !isNaN(this.audioArray[k].duration)) {
        this.audioArray[k].pause();
        this.audioArray[k].currentTime = 0;
      }
    }

    // play clicked
    if (i === -1){ // never played before
      el.parentNode.classList.add('loading');
      this.fileNameArray.push(soundFile);
      i = this.fileNameArray.indexOf(soundFile);
      this.audioArray[i] = new Audio(soundFileUrl);

      this.audioArray[i].onplay=function() {
        el.parentNode.classList.remove('loading');
        el.parentNode.classList.remove('pause');
        el.parentNode.classList.add('playing');
      };

      this.audioArray[i].onpause = function() {
        el.parentNode.classList.remove('playing');
        el.parentNode.classList.add('pause');
      };

      this.audioArray[i].onended = function() {
        el.parentNode.classList.remove('playing');
        el.parentNode.classList.remove('pause');
      };

      this.audioArray[i].loop = 0;
      this.audioArray[i].volume = 1;
      this.audioArray[i].play();

    } else { // has played or is playing.. or was loading
      if (this.audioArray[i].readyState === 0) {
        el.parentNode.classList.remove('loading');
      } else {
        this.audioArray[i].onplay = function() {
          el.parentNode.classList.remove('loading');
          el.parentNode.classList.remove('pause');
          el.parentNode.classList.add('playing');
        };

        if (this.audioArray[i].paused) {
          this.audioArray[i].play();
        } else {
          this.audioArray[i].pause();
        }
      }
    }

    if (mode) {
      this.updateResultMatrix(soundFile, mode);
      this._checkCompleted(mode);
    }
  }

  /**
   * Plays audio associated with button data attr.
   * @param ev
   * @private
   */
  _handlePlayEvent(ev) {
    ev.preventDefault();
    this.play(ev.target);
  }

  /**
   * Bind behaviors to play buttons
   * @param el
   * @private
   */
  _bindPlayEvent(el) {
    el.addEventListener('click', this._handlePlayEvent.bind(this));
    el.addEventListener('touchstart', this._handlePlayEvent.bind(this));
    return el;
  }

  /**
   * Factory method for binding behavior to play buttons.
   * @return {any[]}
   * @private
   */
  _playButtonFactory() {
    const playButtons = Array.from(document.querySelectorAll(this.selectors.playButton));

    return playButtons.map((el) => {
      const instanceKey = 'data-play-button-instance';
      const cachePlayButton = el.getAttribute(instanceKey);
      if (cachePlayButton) {
        return cachePlayButton;
      }
      const playButton = this._bindPlayEvent(el);
      el.setAttribute(instanceKey, playButton);
      return playButton;
    });
  }

  /**
   *
   * @param soundFile
   */
  clearLast(soundFile){
    const tmp = soundFile.split('_');
    for (let k = 0; k < this.tetraHearingDBHL.length; k++) {
      document.getElementById(`${tmp[0]}_${tmp[1]}_${this.tetraHearingDBHL[k]}_${tmp[3]}`).parentNode.classList.remove('selected');
    }
  }

  /**
   * Sets Pagination UI states.
   * @private
   */
  _resetPaginationInterface() {
    const prev = document.querySelectorAll(this.selectors.paginationPrev).item(0);
    const next = document.querySelectorAll(this.selectors.paginationNext).item(0);
    const paginationButtons = Array.from(document.querySelectorAll(this.selectors.paginationBtn));
    const paginationLabel = document.querySelectorAll(this.selectors.stepLabel).item(0);

    paginationButtons.forEach(el => {
      if (el.getAttribute('data-page') === this.page) {
        el.parentNode.classList.add('active');
      } else {
        el.parentNode.classList.remove('active');
      }
    });

    prev.setAttribute('data-page', (parseInt(this.page) - 1));
    next.setAttribute('data-page', (parseInt(this.page) + 1));

    if (prev.getAttribute('data-page') < 1) {
      prev.disabled = true;
    } else {
      prev.disabled = false;
    }

    this._setNextControlState();

    paginationLabel.innerText = this.page;
  }

  _setNextControlState() {
    const nextEl = document.querySelectorAll(this.selectors.paginationNext).item(0);

    if ((this.page === "2" && !this.validation['R']) || (this.page === "3" && !this.validation['L']) || this.page === "4") {
      nextEl.disabled = true;
    } else {
      nextEl.disabled= false;
    }
  }

  _setPaginationState() {
    const paginationBtns = Array.from(document.querySelectorAll(this.selectors.paginationBtn));

    if (this.page === "2" && this.validation['R']) {
      paginationBtns[2].classList.remove('disabled');
    }

    if (this.page === "3" && this.validation['L']) {
      paginationBtns[3].classList.remove('disabled');
    }
  }

  /**
   * Sets selected page to active.
   * @private
   */
  _switchActivePage() {
    const pages = Array.from(document.querySelectorAll(this.selectors.page));
    const activePage = document.getElementById(this.pageId[this.page]);
    const pageTopAnchor = document.getElementById(this.selectors.pageTop);

    pages.forEach((el) => {
      el.classList.remove('active');
    });

    activePage.classList.add('active');
    pageTopAnchor.scrollIntoView();
    this._setNextControlState();
  }

  /**
   * Event Handler
   * @param ev
   * @private
   */
  _handlePaginationEvent(ev) {
    const el = ev.target;

    if (el.classList.contains('disabled')) {
      return;
    }

    this.page = el.getAttribute('data-page') ? el.getAttribute('data-page') : el.parentNode.getAttribute('data-page') ;
    this._switchActivePage();
    this._resetPaginationInterface();

    switch(this.page) {
      case "1":
        window.dataLayer.push({'event': 'htStep1'});
        break;
      case "2":
        window.dataLayer.push({'event': 'htStep2'});
        break;
      case "3":
        window.dataLayer.push({'event': 'htStep3'});
        break;
      case "4":
        window.dataLayer.push({'event': 'htStep4'});
        break;
    }

    if (this.page === "4") {
      this._clearResultMatrix();
      this._resetHubSpotInputField();
      //this._resetEmailContainers();
      this._plotResultMatrix();
      // Submit page 4 hubspot form.
      document.getElementById('hsForm_81610845-f4e1-4819-a626-54b6f4af0c4f').submit();
    }
  }

  /**
   * Binds Pagination events.
   * @param el
   * @return {*}
   * @private
   */
  _bindPaginationEvent(el) {
    el.addEventListener('click', this._handlePaginationEvent.bind(this));
    el.addEventListener('touchstart', this._handlePaginationEvent.bind(this));
    return el;
  }

  /**
   * Builds pagination buttons.
   * @return {any[]}
   * @private
   */
  _paginationButtonFactory() {
    const pagButtons = Array.from(document.querySelectorAll(this.selectors.paginationBtn));

    return pagButtons.map((el) => {
      const instanceKey = 'data-pagination-button-instance';
      const cachePagButton = el.getAttribute(instanceKey);
      if (cachePagButton) {
        return cachePagButton;
      }
      const pagButton = this._bindPaginationEvent(el);
      el.setAttribute(instanceKey, pagButton);
      return pagButton;
    });
  }

  /**
   * Builds control button for pagination.
   * @return {any[]}
   * @private
   */
  _paginationControlFactory() {
    const pagControls = Array.from(document.querySelectorAll(this.selectors.paginationControl));

    return pagControls.map((el) => {
      const instanceKey = 'data-pagination-control-instance';
      const cacheControlButton = el.getAttribute(instanceKey);
      if (cacheControlButton) {
        return cacheControlButton;
      }
      const controlButton = this._bindPaginationEvent(el);
      el.setAttribute(instanceKey, controlButton);
      return controlButton;
    });
  }

  /**
   * Removes copy from HubSpot TextArea Field
   * @private
   */
  _resetHubSpotInputField() {
    document.querySelectorAll(this.selectors.hsResultsContainer).item(0).querySelectorAll('[name="hearing_test_results___online"]').item(0).value = "";
    document.querySelectorAll(this.selectors.hsCategoryContainer).item(0).querySelectorAll('[name="hearing_test_results_category"]').item(0).value = "";
  }

  _handleTabEvent(ev) {
    ev.preventDefault();
    const el = ev.target.getAttribute('data-tab') ? ev.target : ev.target.parentNode;
    const container = document.querySelectorAll(this.selectors.resultsContainer).item(0);

    container.classList.remove('field-view');
    container.classList.remove('clinical-view');
    container.classList.add(el.getAttribute('data-tab'));

    this.tabs.forEach(el => {
      el.classList.remove('active');
    });

    el.classList.add('active');

  }

  _bindTabEvent(el) {
    el.addEventListener('click', this._handleTabEvent.bind(this));
    el.addEventListener('touchstart', this._handleTabEvent.bind(this));
    return el;
  }

  _tabFactory(){
    const tabButton = Array.from(document.querySelectorAll(this.selectors.tabButton));

    return tabButton.map((el) => {
      const instanceKey = 'data-tab-button';
      const cacheTabButton = el.getAttribute(instanceKey);
      if (cacheTabButton) {
        return cacheTabButton;
      }
      const tabButton = this._bindTabEvent(el);
      el.setAttribute(instanceKey, tabButton);
      return tabButton;
    });
  }

  _init() {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event': 'htStep1'});

    // Adds htSignUp form handler
    this.htSignUpForm.addEventListener('submit', htSignUpHandler);

    const emailBtn = document.querySelectorAll(this.selectors.resultsEmailBtn).item(0);
    // initialize result Matrix
    this.resultMatrix["B"]=[];
    this.resultMatrix["R"]=[];
    this.resultMatrix["L"]=[];

    for (let i=0; i < this.allHearingBands.length; i++){
      this.resultMatrix["B"][this.allHearingBands[i]] = [];
      this.resultMatrix["L"][this.allHearingBands[i]] = [];
      this.resultMatrix["R"][this.allHearingBands[i]] = [];
    }
    // set to all zeroes
    this.initResultMatrix();
    this.checkAudioFileCompatibility();

    // Initialize Left Ear Table
    this.tableGen({
      freqs: this.tetraHearingBands,
      dBHLs: this.tetraHearingDBHL,
      mode: 'L',
      tableId: 'leftEar'
    });

    // Initialize Right Ear Table
    this.tableGen({
      freqs: this.tetraHearingBands,
      dBHLs: this.tetraHearingDBHL,
      mode: 'R',
      tableId: 'rightEar'
    });

    // Generate Results Grid.
    this.genResultsGrid();

    //this.checkMatrixDataFromURL();

    // Initialize pagination
    this._paginationButtonFactory();
    this._paginationControlFactory();
    this.tabs = this._tabFactory();

  }
}
